<template>
  <div>
    <v-progress-linear v-if="cargando" indeterminate color="purple" class="mb-2" />

    <ag-grid-vue
      :gridOptions="gridOptions"
      class="ag-theme-balham"
      :class="{
        'ag-grid-listado-inscripcion-programa-universidad-largo': esLargo,
        'ag-grid-listado-inscripcion-programa-universidad': !esLargo,
      }"
      :columnDefs="columnDefs"
      :defaultColDef="defaultColDef"
      @grid-ready="onGridReady"
      :rowData="rowData"
      :rowSelection="rowSelection"
      colResizeDefault="shift"
      :animateRows="false"
      :floatingFilter="true"
      :pagination="false"
      :rowClassRules="rowClassRules"
      @selection-changed="onSelectionChanged"
      @first-data-rendered="onFirstDataRendered"
      @row-data-updated="onRowDataUpdated"
      :alwaysShowVerticalScroll="true"
      :suppressPaginationPanel="true"
      :suppressRowClickSelection="seleccionTodos"
      :isRowSelectable="isRowSelectable">
    </ag-grid-vue>
  </div>
</template>
  
<script>
import listadoAgGridMixin from '../mixins/listado-ag-grid.mixin';
import {
  cellRendererNumeroRegistro,
  cellRendererSiONo,
  formatearValorAMoneda,
  imprimirModulo,
  imprimirProgramaModulo,
  obtenerInscripcionModuloMasAlto,
  obtenerModuloMasAlto,
} from '../utils/funciones';
import { mapGetters } from 'vuex';
import listadoCuotaAnteriorMixin from '../mixins/listado-cuota-anterior.mixin';
import {
  COLORES_ESTADOS_ADMINISTRATIVOS,
  COLORES_ESTADOS_CARTERA,
  ESTADOS_INSCRIPCION,
  FASES_PROGRAMA,
  TIPO_VERIFICACION_SOLICITUDES_PAGOS,
} from '../utils/constantes';
import Boton2HistorialEstadosAcademicos from './Boton2HistorialEstadosAcademicos.vue';
import BotonModuloActual2 from './BotonModuloActual2.vue';
import BotonModulos2 from './BotonModulos2.vue';
import BotonMontoTotalConceptos2 from './BotonMontoTotalConceptos2.vue';
import columnasMontosMixin from '../mixins/columnas-montos.mixin';

export default {
  name: 'ListadoInscripcionProgramaUniversidad',
  mixins: [listadoAgGridMixin, listadoCuotaAnteriorMixin, columnasMontosMixin],
  components: {
    // eslint-disable-next-line vue/no-unused-components
    Boton2HistorialEstadosAcademicos,
    // eslint-disable-next-line vue/no-unused-components
    BotonModuloActual2,
    // eslint-disable-next-line vue/no-unused-components
    BotonModulos2,
    // eslint-disable-next-line vue/no-unused-components
    BotonMontoTotalConceptos2,
  },
  props: {
    rowSelection: {
      type: String,
      default: 'single',
      validator: (value) => ['single', 'multiple'].includes(value),
    },
    itemsYaSeleccionados: {
      type: Array,
      default: () => [],
    },
    itemsYaSolicitados: {
      type: Array,
      default: () => [],
    },
    mostrarColumnaSolicitado: {
      type: Boolean,
      default: false,
    },
    seleccionTodos: {
      type: Boolean,
      default: false,
    },
    esLargo: {
      type: Boolean,
      default: false,
    },
    detallePlanPagoConceptoUniversidad: {
      type: Object,
      default: null,
    },
  },
  created() {
    const conceptoUniversidad =
      this.detallePlanPagoConceptoUniversidad?.planPagoConceptoUniversidad?.conceptoUniversidad;
    const universidadId = conceptoUniversidad?.universidadId;

    this.obtenerConfiguraciones(universidadId).then(() => {
      const esTipoVerificacionPorConcepto =
        this.configuraciones?.tipoVerificacionSolicitudesPagos == TIPO_VERIFICACION_SOLICITUDES_PAGOS.POR_CONCEPTO;
      const esTipoVerificacionPorTotal =
        this.configuraciones?.tipoVerificacionSolicitudesPagos == TIPO_VERIFICACION_SOLICITUDES_PAGOS.POR_EL_TOTAL;

      this.isRowSelectable = (params) => {
        const inscripcion = params.data.inscripcion;
        const esVerificable = conceptoUniversidad?.esVerificable;
        const conceptoPagoAVerificar = conceptoUniversidad?.conceptoPagoEquivalente;
        const conceptoPago = inscripcion?.conceptosPagos?.find((concepto) => concepto.id == conceptoPagoAVerificar?.id);
        const saldo = inscripcion?.conceptosPagos?.reduce((acumulador, concepto) => acumulador + concepto.saldo, 0);

        return (
          !!params.data &&
          !this.yaSeleccionados.some((item) => item.inscripcionProgramaUniversidadId === params.data.id) &&
          (!this.getFiltrarPorSede || inscripcion.programa.sedeId == this.$store?.state?.cargo_sede?.sede?.id) &&
          (!this.configuraciones?.verificarSolicitudesPagosEstadoActual || inscripcion.estadoInscripcion == 1) &&
          (!esTipoVerificacionPorConcepto ||
            !esVerificable ||
            !conceptoPagoAVerificar ||
            !conceptoPago ||
            (conceptoPago?.saldo == 0 &&
              (!this.configuraciones?.verificarSolicitudesPagosEstadoActual || inscripcion.estadoInscripcion == 1))) &&
          (!esTipoVerificacionPorTotal ||
            (saldo == 0 &&
              (!this.configuraciones?.verificarSolicitudesPagosEstadoActual || inscripcion.estadoInscripcion == 1))) &&
          (!this.configuraciones?.verificarSolicitudesPagosCuotaAnterior ||
            params.data.estadoCuotaAnterior !== 'no pagada')
        );
      };

      if (this.mostrarColumnaSolicitado) {
        if (esTipoVerificacionPorConcepto) {
          this.agregarColumnaConceptoAVerificar(2);
        } else if (esTipoVerificacionPorTotal) {
          this.agregarColumnaSaldoTotalPendiente(2);
        }

        this.gridApi?.refreshCells();
      }
    });

    if (this.mostrarColumnaSolicitado) {
      this.agregarColumnaSolicitado(2);

      this.gridApi?.refreshCells();
    }

    if (this.mostrarColumnaCuotaAnterior) {
      this.agregarColumnaEstadoCuotaAnterior(3);

      this.gridApi?.refreshCells();
    }

    this?.agGridApi?.setGridOptions('columnDefs', this.columnDefs);
  },
  computed: {
    rowData() {
      const itemsFiltradosPorSede = this.getFiltrarPorSede
        ? this.items.filter((item) => item.inscripcion.programa.sedeId == this.$store?.state?.cargo_sede?.sede?.id)
        : this.items;

      return itemsFiltradosPorSede.map((item) => {
        return {
          ...item,
          solicitado: this.itemsYaSolicitados.some(
            (solicitado) => solicitado.inscripcionProgramaUniversidadId === item.id,
          ),
          estadoCuotaAnterior:
            this.detallePagoConceptoUniversidadCuotaAnterior == null
              ? 'sin cuota anterior'
              : this.inscripcionesProgramasUniversidadesPagadasDeCuotaAnterior.some(
                  (inscripcionPrograma) => inscripcionPrograma.id === item.id,
                )
              ? 'pagada'
              : 'no pagada',
        };
      });
    },
    yaSeleccionados() {
      return [...this.itemsYaSeleccionados, ...this.itemsYaSolicitados];
    },
    ...mapGetters('pago', ['getFiltrarPorSede']),
    universidadId() {
      if (this.rowData.length > 0) {
        return this.rowData[0]?.inscripcion?.programa?.universidadId;
      }

      return null;
    },
  },
  watch: {
    detallePagoConceptoUniversidadCuotaAnterior: {
      handler: function () {
        this.gridApi?.refreshHeader();
      },
      deep: true,
      immediate: true,
    },
    universidadId: {
      handler(value) {
        if (value == this.universidadIdUnivPando) {
          this.quitarColumnasPagos();
        } else {
          this.agregarColumnasPagos();
        }

        this?.agGridApi?.setGridOptions('columnDefs', this.columnDefs);
      },
      immediate: true,
    },
  },
  data() {
    return {
      isRowSelectable: null,
      universidadIdUnivPando: 49,
      columnDefs: [
        {
          headerName: 'N° REGISTRO',
          cellRenderer: cellRendererNumeroRegistro,
          filter: false,
          checkboxSelection: () => {
            return !this.seleccionTodos;
          },
          headerCheckboxSelectionFilteredOnly: true,
          headerCheckboxSelection: !this.seleccionTodos,
          showDisabledCheckboxes: this.seleccionTodos,
          minWidth: 130,
          maxWidth: 130,
        },
        {
          headerName: 'N° DOCUMENTO',
          field: 'inscripcion.estudiante.numeroDocumento',
          minWidth: 120,
          maxWidth: 120,
        },
        {
          headerName: 'ESTADO ACTUAL',
          cellRenderer: (params) => {
            const estadoInscripcion = params.data?.inscripcion?.estadoInscripcion;
            const estado = ESTADOS_INSCRIPCION[estadoInscripcion];
            let color = 'black';

            if (estadoInscripcion == 1) {
              color = 'green';
            } else if (estadoInscripcion == 2) {
              color = 'red';
            } else {
              color = 'blue';
            }

            return /*html*/ `
                  <span class="v-chip v-chip--outlined v-chip--pill theme--dark v-size--x-small ${color} ${color}--text body-2">
                      <span class="v-chip__content">
                        ${estado}
                      </span>
                  </span>
                `;
          },
          filter: true,
          valueGetter: (params) => {
            const estadoInscripcion = params.data?.inscripcion?.estadoInscripcion;

            return ESTADOS_INSCRIPCION[estadoInscripcion];
          },
          minWidth: 150,
          maxWidth: 150,
        },
        {
          headerName: 'ESTADO DE CARTERA',
          cellRenderer: (params) => {
            const estadoCartera = params.data?.inscripcion?.estadoCartera.nombre;

            if (!estadoCartera) {
              return '-';
            }

            const color = COLORES_ESTADOS_CARTERA[estadoCartera] || 'black';

            return /*html*/ `
                  <span class="v-chip v-chip--outlined v-chip--pill theme--dark v-size--x-small ${color} ${color}--text body-2">
                      <span class="v-chip__content">
                        ${estadoCartera}
                      </span>
                  </span>
                `;
          },
          filter: true,
          valueGetter: (params) => {
            const estadoCartera = params.data?.inscripcion?.estadoCartera.nombre;

            return estadoCartera;
          },
          minWidth: 220,
          maxWidth: 220,
        },
        {
          headerName: 'ESTADO ADMINISTRATIVO',
          cellRenderer: (params) => {
            const estadoAdministrativo = params.data?.inscripcion?.estadoAdministrativo.nombre;

            if (!estadoAdministrativo) {
              return '-';
            }

            const color = COLORES_ESTADOS_ADMINISTRATIVOS[estadoAdministrativo] || 'black';

            return /*html*/ `
                  <span class="v-chip v-chip--outlined v-chip--pill theme--dark v-size--x-small ${color} ${color}--text body-2">
                      <span class="v-chip__content">
                        ${estadoAdministrativo}
                      </span>
                  </span>
                `;
          },
          filter: true,
          valueGetter: (params) => {
            const estadoAdministrativo = params.data?.inscripcion?.estadoAdministrativo.nombre;

            if (!estadoAdministrativo) {
              return '-';
            }

            return estadoAdministrativo;
          },
          minWidth: 180,
          maxWidth: 180,
        },
        {
          headerName: 'ESTADO ACADÉMICO',
          cellRenderer: 'Boton2HistorialEstadosAcademicos',
          valueGetter: (params) => {
            const estadoAcademico = params.data?.inscripcion?.estadoAcademico?.nombre;

            return estadoAcademico;
          },
          filter: true,
          minWidth: 250,
          maxWidth: 250,
        },
        {
          headerName: 'MÓDULO ACTUAL',
          cellRenderer: 'BotonModuloActual2',
          filter: true,
          valueGetter: (params) => {
            const inscripcionesModulos = params.data?.inscripcion?.inscripcionesModulos;
            const inscripcionModuloMasAlto = obtenerInscripcionModuloMasAlto(inscripcionesModulos);

            return imprimirProgramaModulo(inscripcionModuloMasAlto);
          },
          minWidth: 200,
          maxWidth: 200,
        },
        {
          headerName: 'EXPEDIDO',
          cellRenderer: (params) => {
            const expedido = params.data?.inscripcion?.estudiante?.departamento?.extension.toUpperCase();

            return expedido || '-';
          },
          valueGetter: (params) => {
            return params.data?.inscripcion?.estudiante?.departamento?.extension;
          },
          false: false,
          minWidth: 100,
          maxWidth: 100,
        },
        {
          headerName: 'ESTADO',
          cellRenderer: (params) => {
            const estado = params.data?.estado?.toUpperCase();

            return estado;
          },
          filter: false,
          minWidth: 120,
          maxWidth: 120,
        },
        {
          headerName: 'PRIMER APELLIDO',
          field: 'inscripcion.estudiante.primerApellido',
          minWidth: 180,
        },
        {
          headerName: 'SEGUNDO APELLIDO',
          field: 'inscripcion.estudiante.segundoApellido',
          minWidth: 180,
        },
        {
          headerName: 'NOMBRES',
          field: 'inscripcion.estudiante.nombres',
          minWidth: 200,
        },
        {
          headerName: 'MÓDULO PROGRAMA',
          cellRenderer: 'BotonModulos2',
          filter: true,
          valueGetter: (params) => {
            const programasModulos = params.data?.inscripcion?.programa?.programasModulos;
            const inscripcionModuloMasAlto = obtenerModuloMasAlto(programasModulos);

            return imprimirModulo(inscripcionModuloMasAlto);
          },
          minWidth: 150,
          maxWidth: 150,
        },
        {
          headerName: 'ID PROGRAMA',
          field: 'inscripcion.programa.id',
          minWidth: 120,
          maxWidth: 120,
        },
        {
          headerName: 'PROGRAMA',
          field: 'inscripcion.programa.nombreCompuesto',
          minWidth: 600,
        },
        {
          headerName: 'FASE',
          field: 'inscripcion.programa.fase',
          minWidth: 200,
          maxWidth: 200,
          valueGetter: (params) => {
            return FASES_PROGRAMA[params.data.inscripcion.programa.fase] || 'DESCONOCIDO';
          },
        },
        {
          headerName: 'SEDE',
          field: 'inscripcion.programa.sede.nombre',
          minWidth: 160,
          maxWidth: 160,
        },
        {
          headerName: 'GÉNERO',
          cellRenderer: (params) => {
            const genero = params?.data?.inscripcion?.estudiante?.sexo;

            return genero === 'M' ? 'MASCULINO' : 'FEMENINO';
          },
          filter: false,
          minWidth: 100,
          maxWidth: 100,
        },
        {
          headerName: 'CELULAR',
          cellRenderer: (params) => {
            const estudiante = params?.data?.inscripcion?.estudiante;
            const celular = estudiante?.telefono1 || estudiante?.telefono2;

            return celular || '-';
          },
          minWidth: 120,
          maxWidth: 120,
        },
        {
          headerName: 'CORREO',
          cellRenderer: (params) => {
            const correo = params?.data?.inscripcion?.estudiante?.email;

            return correo || '-';
          },
          minWidth: 250,
        },
        {
          headerName: 'PROFESIÓN',
          cellRenderer: (params) => {
            const profesiones = params?.data?.inscripcion?.estudiante?.profesiones;

            return profesiones?.length ? profesiones[0].nombre : '-';
          },
          minWidth: 250,
        },
        {
          headerName: 'UNIV. TITULACIÓN',
          cellRenderer: (params) => {
            const universidad = params?.data?.inscripcion?.estudiante?.institucion?.nombre;

            return universidad || '-';
          },
          minWidth: 450,
        },
        {
          headerName: 'CÓDIGO DE EMPASTADO',
          cellRenderer: (params) => {
            const codigoEmpastado = params?.data?.codigoEmpastado;

            return codigoEmpastado || '-';
          },
          minWidth: 450,
        },
      ],
      columnasPagos: [
        {
          headerName: 'PAGO MÁTRICULA',
          cellRenderer: (params) => {
            const inscripcion = params.data?.inscripcion;
            const montos = inscripcion?.montos;

            if (!montos) {
              return '-';
            }

            return formatearValorAMoneda(montos?.pagoMatricula);
          },
          filter: false,
          minWidth: 150,
          maxWidth: 150,
          type: 'numericColumn',
        },
        {
          headerName: 'PAGO COLEGIATURA',
          cellRenderer: (params) => {
            const inscripcion = params.data?.inscripcion;
            const montos = inscripcion?.montos;

            if (!montos) {
              return '-';
            }

            return formatearValorAMoneda(montos?.pagoColegiatura);
          },
          filter: false,
          minWidth: 150,
          maxWidth: 150,
          type: 'numericColumn',
        },
        {
          headerName: 'PAGO CERTIFICACIÓN',
          cellRenderer: (params) => {
            const inscripcion = params.data?.inscripcion;
            const montos = inscripcion?.montos;

            if (!montos) {
              return '-';
            }

            return formatearValorAMoneda(montos?.pagoCertificacion);
          },
          filter: false,
          minWidth: 150,
          maxWidth: 150,
          type: 'numericColumn',
        },
        {
          headerName: 'MONTO TOTAL PAGADO',
          cellRenderer: 'BotonMontoTotalConceptos2',
          filter: false,
          minWidth: 200,
          maxWidth: 200,
          type: 'numericColumn',
        },
      ],
    };
  },
  methods: {
    onRowDataUpdated(params) {
      if (this.seleccionTodos) {
        params.api.forEachNode((node) => {
          node.setSelected(true);
        });
      }
    },
    onSelectionChanged() {
      this.selectedRows = this.gridApi.getSelectedRows();

      if (this.rowSelection === 'single') {
        this.$emit('selectItem', this.selectedRows.length > 0 ? this.selectedRows[0] : null);
      } else {
        this.$emit('selectItem', this.selectedRows);
      }
    },
    agregarColumnaSolicitado(indiceColumna) {
      this.columnDefs.splice(indiceColumna, 0, {
        headerName: 'SOLICITADO',
        field: 'solicitado',
        cellRenderer: cellRendererSiONo('solicitado', 'SI', 'NO'),
        filter: false,
        minWidth: 120,
        maxWidth: 120,
      });
    },
    agregarColumnaConceptoAVerificar(indiceColumna) {
      this.columnDefs.splice(indiceColumna, 0, {
        headerName: 'CONCEPTO A VERIFICAR',
        cellRenderer: (params) => {
          const conceptosPagos = params.data?.inscripcion?.conceptosPagos;
          const conceptoPagoAVerificar =
            this.detallePlanPagoConceptoUniversidad.planPagoConceptoUniversidad.conceptoUniversidad
              ?.conceptoPagoEquivalente;

          const conceptoPago = conceptosPagos?.find((concepto) => concepto.id == conceptoPagoAVerificar?.id);
          const color = conceptoPago?.saldo > 0 ? 'red' : 'green';

          if (conceptoPago) {
            return /*html*/ `
                  <span class="v-chip v-chip--outlined v-chip--pill theme--dark v-size--x-small ${color} ${color}--text body-2">
                      <span class="v-chip__content">
                        ${conceptoPago.nombre.toUpperCase()}
                        (Saldo: ${formatearValorAMoneda(conceptoPago.saldo)})
                      </span>
                  </span>
                `;
          }

          return '-';
        },
        filter: false,
        minWidth: 300,
      });
    },
    agregarColumnaSaldoTotalPendiente(indiceColumna) {
      this.columnDefs.splice(indiceColumna, 0, {
        headerName: 'SALDO TOTAL PENDIENTE',
        cellRenderer: (params) => {
          const conceptosPagos = params.data?.inscripcion?.conceptosPagos;
          const saldo = conceptosPagos?.reduce((acumulador, concepto) => acumulador + concepto.saldo, 0);
          const color = saldo > 0 ? 'red' : 'green';

          return /*html*/ `
                <span class="v-chip v-chip--outlined v-chip--pill theme--dark v-size--x-small ${color} ${color}--text body-2">
                    <span class="v-chip__content">
                      ${formatearValorAMoneda(saldo)}
                    </span>
                </span>
              `;
        },
        filter: false,
        minWidth: 200,
      });
    },
  },
};
</script>
  
<style>
@import '~ag-grid-community/dist/styles/ag-grid.css';
@import '~ag-grid-community/dist/styles/ag-theme-balham.css';

.ag-grid-listado-inscripcion-programa-universidad-largo {
  height: calc(var(--vh, 1vh) * 100 - 18rem);
}

.ag-grid-listado-inscripcion-programa-universidad {
  height: calc(var(--vh, 1vh) * 100 - 24rem);
}
</style>
  